import {getAttrById, findCurrentComponentPathInLayoutByRectId, simpleDeepClone} from "utils"
import {isExist, deletePage, getAllRectInNewLayout} from "../../../utils"
import {param} from "jquery"
// 导入store
import store from "../../../store"
import Vue from "vue";

export default function publicActions(types) {
    return {
        changeVDROptions({commit}, data) {
            commit(types.CHANGE_VDR_OPTIONS, data)
        },
        updateRectModuleIdTypeId({commit}, data) {
            commit(types.UPDATE_RECT_MODULE_ID_TYPE_ID, data)
        },
        updateColsOption({commit}, data) {
            commit(types.UPDATE_COLS_OPTION, data)
        },
        updateColLenInLayout({commit}, data) {
            commit(types.UPDATE_COL_LEN_IN_LAYOUT, data)
        },
        updateRowLenInLayout({commit}, data) {
            commit(types.UPDATE_ROW_LEN_IN_LAYOUT, data)
        },
        updateCreateBlockTimes({commit}, data) {
            commit(types.UPDATE_CREATE_BLOCK_TIMES, data)
        },
        changeBigScreenOption({commit}, data) {
            commit(types.CHANG_BIG_SCREEN_OPTION, data)
        },
        initWebJson({commit}, data) {
            commit(types.INIT_STAGE_DATA, data)
        },
        updateAppId({commit}, data) {
            commit(types.UPDATE_APPID, data)
        },
        addLayoutBlock({commit}, data) {
            commit(types.ADD_LAYOUT_BLOCK, data)
        },
        resetLayoutBlock({commit}, data) {
            commit(types.RESET_LAYOUT_BLOCK, data)
        },
        delLayoutCol({commit}, data) {
            commit(types.DEL_LAYOUT_COL, data)
        },
        pasteLayoutCol({commit}, data) {
            commit(types.PASTE_LAYOUT_COL, data)
        },
        addLayoutCol({commit}, data) {
            commit(types.ADD_LAYOUT_COL, data)
        },
        exchangeLayoutCol({commit}, data) {
            commit(types.EXCHANGE_LAYOUT_COL, data)
        },
        delLayoutElement({commit}, data) {
            commit(types.DEL_LAYOUT_ELEMENT, data)
        },
        delLayoutAroundElement({commit}, data) {
            commit(types.DEL_LAYOUT_AROUND_ELEMENT, data)
        },
        changeColsSize({commit}, data) {
            commit(types.CHANGE_LAYOUT_SIZE, data)
        },
        changeLayoutOption({commit}, data) {
            commit(types.CHANGE_LAYOUT_OPTION, data)
        },
        changeLayoutActive({commit}, data) {
            //默认修改当前col的active
            commit(types.CHANGE_LAYOUT_ACTIVE, data)
        },
        /*
          tabbar事件👇
          */
        changeLayoutTitleActive({commit, state}, data) {
            let dataSource = getAttrById(state, {container_id: data.container_id, rect_id: data.rect_id}).options
                .titleOptions
            if (data.elementInAutoLayoutId !== undefined) {
                dataSource = getAttrById(
                    state,
                    {
                        container_id: data.container_id,
                        rect_id: data.rect_id,
                        elementInAutoLayoutId: data.elementInAutoLayoutId,
                        path: data.path
                    },
                    "elementInAutoLayout"
                )?.titleOptions
            }
            for (let i = 0; i < dataSource.length; i++) {
                for (let j = 0; j < dataSource[i].elementOptions.length; j++) {
                    if (
                        i === data.directionIndex &&
                        dataSource[i].elementOptions[j].elementInLayoutId === data.elementInLayoutId
                    ) {
                        commit(types.CHANGE_LAYOUT_TITLE_ACTIVE, data)
                        continue
                    }
                    const temp = {
                        container_id: data.container_id,
                        rect_id: data.rect_id,
                        directionIndex: i,
                        elementInLayoutId: dataSource[i].elementOptions[j].elementInLayoutId,
                        elementInAutoLayoutId: data.elementInAutoLayoutId,
                        path: data.path
                    }
                    if (
                        dataSource[
                            i
                            ].elementOptions.find(it => it.elementInLayoutId === dataSource[i].elementOptions[j].elementInLayoutId)
                            .isActive
                    ) {
                        commit(types.CHANGE_LAYOUT_TITLE_DISABLE_ACTIVE, temp)
                    }
                }
            }
        },
        changeTabsActiveIndex({commit}, data) {
            commit(types.CHANGE_TABS_ACTIVE_INDEX, data)
        },
        changeAnchorActiveIndex({commit}, data) {
            commit(types.CHANGE_ANCHOR_ACTIVE_INDEX, data)
        },
        changeTabsTitle({commit}, data) {
            commit(types.CHANGE_TABS_TITLE, data)
        },
        changeTabMapRowContent({commit}, data) {
            commit(types.CHANGE_TAB_MAP_ROW_CONTENT, data)
        },
        changeTabsOrder({commit}, data) {
            commit(types.CHANGE_TABS_ORDER, data)
        },
        /*
          tabbar事件👆
            */
        delAllLayoutTitleActive({commit, state}, data) {
            if (data.rect_id === null || typeof data.rect_id === "undefined" || data.rect_id !== data.rect_id) {
                return
            }
            let dataSource = getAttrById(state, {container_id: data.container_id, rect_id: data.rect_id})?.options
                .titleOptions
            if (!dataSource && data.elementInAutoLayoutId !== undefined) {
                dataSource = getAttrById(state, data, "elementInAutoLayout")?.titleOptions
            }
            if (!dataSource) {
                return
            }
            for (let i = 0; i < dataSource.length; i++) {
                for (let j = 0; j < dataSource[i].elementOptions.length; j++) {
                    if (dataSource[i].elementOptions[j].isActive) {
                        const temp = {
                            container_id: data.container_id,
                            rect_id: data.rect_id,
                            directionIndex: i,
                            elementInLayoutId: dataSource[i].elementOptions[j].elementInLayoutId,
                            elementInAutoLayoutId: data.elementInAutoLayoutId,
                            path: data.path
                        }
                        commit(types.CHANGE_LAYOUT_TITLE_DISABLE_ACTIVE, temp)
                        break
                    }
                }
            }
        },
        layoutTitleDisableActive({commit, state}, data) {
            commit(types.CHANGE_LAYOUT_TITLE_DISABLE_ACTIVE, data)
        },
        layoutTitleComponentDisplayHandle({commit, state}, data) {
            commit(types.CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE, data)
        },
        layoutTitleDisplayIsShow({commit, state}, data) {
            commit(types.CHANGE_LAYOUT_TITLE_DISPLAY_SHOW, data)
        },
        layoutTitleDisplay({commit, state}, data) {
            commit(types.CHANGE_LAYOUT_TITLE_DISPLAY, data)
        },
        addComponentInLayoutAround({commit}, data) {
            commit(types.ADD_COMPONENT_IN_LAYOUT_AROUND, data)
        },
        addComponentInLayout({commit}, data) {
            commit(types.ADD_COMPONENT_IN_LAYOUT, data)
        },
        initLayoutComponent({commit}, data) {
            commit(types.INIT_LAYOUT_COMPONENT, data)
        },
        changeAllOptions({commit}, data) {
            commit(types.CHANGE_OPTIONS, data)
        },
        changeOptions({commit}, data) {
            commit(types.CHANGE_OPTION, data)
        },
        changeStoreOptions({commit}, data) {
            commit(types.CHANGE_STORE_OPTIONS, data)
        },
        changeStoreOptionsNew({commit}, data) {
            commit(types.CHANGE_STORE_OPTIONS_NEW, data)
        },
        initStoreOptions({commit}, data) {
            commit(types.INIT_STORE_OPTIONS, data)
        },
        changeTitleElement({commit}, data) {
            commit(types.CHANGE_LAYOUT_TITLE_ElEMENT, data)
        },
        changeTitleOptions({commit}, data) {
            commit(types.CHANGE_LAYOUT_TITLE_OPTIONS, data)
        },
        delOptionContent({commit}, data) {
            commit(types.DEL_OPTION_CONTENT, data)
        },
        swiperContentControl({commit}, data) {
            commit(types.SWIPER_CONTENT_CONTROL, data)
        },
        swiperContentOptionsUpdate({commit}, data) {
            commit(types.SWIPER_CONTENT_OPTIONS_UPDATE, data)
        },
        swiperContentUpdate({commit}, data) {
            commit(types.SWIPER_CONTENT_UPDATE, data)
        },
        addElement({commit}, data) {
            commit(types.ELEMENT_ADD, data)
        },
        deleteElement({commit, state}, data) {
            console.log("deleteElement==>", data)
            // 将各种组件，单元格，布局的删除放入此处集合
            const keys = Object.keys(data)
            //判断是否每个键值都不为null
            const ableIn = keys.every(item => {
                return item !== null
            })
            let elementInAutoLayout = null
            if (isExist(data.elementInAutoLayoutId) && !isExist(data.directionIndex)) {// 判断当前元素是否在自动布局中
                elementInAutoLayout = getAttrById(state, data, "autoLayout")
            }
            if (isExist(data.cellId) && isExist(data.elementInDataGridId)) {
                commit(types.DEL_ELEMENT_IN_DATAGRID, data)
                commit("states/changeElementType", "cxDataGridCell", {root: true})
                let dataGridCellId = JSON.parse(JSON.stringify(data))
                delete dataGridCellId.elementInDataGridId
                commit("states/changeActiveID", dataGridCellId, {root: true})
                return
            } else if (isExist(data.swiperContent_id) && isExist(data.elementInSwiperId)) {
                // 删除轮播内的组件
                commit(types.DEL_ELEMENT_IN_SWIPER, data)
                commit(
                    "states/changeActiveID",
                    {
                        container_id: data.container_id,
                        rect_id: data.rect_id
                    },
                    {root: true}
                )
                commit("states/changeElementType", "swiperComponent", {root: true})
                commit("states/changeToolBarStatus", false, {root: true})
                commit(types.ENABLE_ACTIVE, {
                    container_id: data.container_id,
                    rect_id: data.rect_id
                })
                return
            } else if (elementInAutoLayout && elementInAutoLayout.innerElement === "cxAutoLayout") {
                // 删除自动布局中的元素
                let param = {
                    container_id: data.container_id,
                    rect_id: data.rect_id,
                    elementInAutoLayoutId: data.elementInAutoLayoutId,
                    path: data.path,
                    uid: data.uid,
                    elementInLayoutId: data.elementInLayoutId,
                }
                commit(types.DEL_ELEMENT_IN_AUTOLAYOUT, param)
                // 激活整个页面 设计师提的
                commit("states/changeElementType", null, {root: true})
                return
            } else if (
                // 删除组件
                !isExist(data.elementInLayoutId) &&
                ableIn &&
                !data.uid &&
                !isExist(data.pageLayoutId)
            ) {
                if (state.page.pageLayoutType) {
                    commit("states/changeElementType", null, {root: true})
                } else {
                    commit("states/changeElementType", state.type === "bigScreen" ? "bigScreenContainer" : "container", {
                        root: true
                    })
                }
            } else if (data.hasOwnProperty("uid") && !data.hasOwnProperty("elementInLayoutId")) {
                // 删除自由布局的单元格
                // 说明是布局组件的单元格
                let param = {
                    container_id: data.container_id,
                    rect_id: data.rect_id,
                    uid: data.uid,
                    elementInAutoLayoutId: data.elementInAutoLayoutId,
                    path: data.path
                }
                commit(types.DEL_LAYOUT_COL, param)
                commit("states/changeElementType", "emptyLayoutComponent", {root: true})
                commit(
                    "states/changeActiveID",
                    {
                        container_id: data.container_id,
                        rect_id: data.rect_id,
                        elementInAutoLayoutId: data.elementInAutoLayoutId,
                        path: data.path
                    },
                    {root: true}
                )
                const container = getAttrById(state, {container_id: data.container_id})
                for (let i = 0, l = container.children.length; i < l; i++) {
                    if (container.children[i].rect_id === data.rect_id) {
                        commit(types.ENABLE_ACTIVE, {
                            container_id: data.container_id,
                            rect_id: container.children[i].rect_id
                        })
                    } else {
                        if (container.children[i].active) {
                            commit(types.DISABLE_ACTIVE, {
                                container_id: data.container_id,
                                rect_id: container.children[i].rect_id
                            })
                        }
                    }
                }
                return
            } else if (typeof data.directionIndex === "number" && !isNaN(data.directionIndex)) {
                // 删除自由布局边栏中的元素
                let param = {
                    container_id: data.container_id,
                    rect_id: data.rect_id,
                    directionIndex: data.directionIndex,
                    elementInLayoutId: data.elementInLayoutId,
                    elementInAutoLayoutId: data.elementInAutoLayoutId,
                    path: data.path,
                    value: false
                }
                commit(types.CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE, param)
                commit(
                    "states/changeActiveID",
                    {
                        container_id: data.container_id,
                        rect_id: data.rect_id,
                        elementInAutoLayoutId: data.elementInAutoLayoutId,
                        path: data.path
                    },
                    {root: true}
                )
                commit("states/changeElementType", "emptyLayoutComponent", {root: true})
                commit(types.ENABLE_ACTIVE, {
                    container_id: data.container_id,
                    rect_id: data.rect_id,
                    elementInAutoLayoutId: data.elementInAutoLayoutId,
                    path: data.path
                })
                return
            } else {
                // 删除自由布局中的元素
                let param = {
                    container_id: data.container_id,
                    rect_id: data.rect_id,
                    elementInLayoutId: data.elementInLayoutId,
                    uid: data.uid,
                    elementInAutoLayoutId: data.elementInAutoLayoutId,
                    path: data.path
                }
                let curRectOptions = getAttrById(state, param, param.elementInAutoLayoutId ? "elementInAutoLayout" : "elementInLayout")
                if (curRectOptions?.popoverPath) {
                    deleteDrawerAndPopover(curRectOptions)
                }
                commit(types.DEL_LAYOUT_ELEMENT, param)
                const emptyLayoutId = {
                    container_id: data.container_id,
                    rect_id: data.rect_id,
                    elementInAutoLayoutId: data.elementInAutoLayoutId,
                    path: data.path
                }
                let rectAttr = getAttrById(state, emptyLayoutId)
                rectAttr = rectAttr.options ? rectAttr.options : rectAttr
                let hideColsComponent = false
                if (rectAttr && rectAttr.pluginName && (rectAttr.pluginName?.includes("loginLayoutComponent") || rectAttr.pluginName?.includes("searchComponentPlugin"))) {
                    hideColsComponent = true
                }
                if (hideColsComponent) {// 隐藏单元格的组件 选中自由布局
                    commit(
                        "states/changeActiveID",
                        emptyLayoutId,
                        {root: true}
                    )
                    commit("states/changeElementType", "emptyLayoutComponent", {root: true})
                    commit(types.ENABLE_ACTIVE, emptyLayoutId)
                } else {
                    commit(
                        "states/changeActiveID",
                        {
                            container_id: data.container_id,
                            rect_id: data.rect_id,
                            uid: data.uid,
                            elementInAutoLayoutId: data.elementInAutoLayoutId,
                            path: data.path
                        },
                        {root: true}
                    )
                    commit("states/changeElementType", "colsComponent", {root: true})
                }
                return
            }

            // 删除带子页面的组件之前，需要先更新子页面映射
            const rectAttr = getAttrById(state, {...data}, "rect")
            if (!rectAttr) {
                // 处理某些脏数据情况，组件已经不存在的情况
                return
            }
            if (
                !!rectAttr?.options.appId &&
                (rectAttr.shape === "emptyLayoutComponent" || rectAttr.shape === "swiperComponent")
            ) {
                // 带appId的布局组件就是样式
                if (state.page.subPages) {
                    let subPages = JSON.parse(JSON.stringify(state.page.subPages))
                    // 找出删除的组件的appId对应的子页面
                    let delSubPage = subPages.filter(item => item.appId === rectAttr.options.appId)
                    console.log("delSubPage==>", delSubPage)
                    console.log("store==>", store.state)
                    subPages = subPages.filter(item => item.appId !== rectAttr.options.appId)
                    commit(types.CHANGE_SUB_PAGE_MAPPING, subPages)
                    if (delSubPage.length > 0) {
                        // 双端subPages是否都不存在该组件
                        let flag = false
                        // pc端
                        let index = store.state.stage.page.subPages?.findIndex(item => item.appId === rectAttr.options.appId)
                        // 移动端
                        let index2 = store.state.appStage.page.subPages?.findIndex(item => item.appId === rectAttr.options.appId)
                        if (index === -1 && index2 === -1) {
                            flag = true
                        }
                        // 是自定义页面
                        if (!delSubPage[0].listPageIsUseSystemTemplate && flag) {
                            // 删除自定义页面
                            deletePage(delSubPage[0].listPageId)
                        }
                        if (!delSubPage[0].detailPageIsUseSystemTemplate && flag) {
                            // 删除自定义页面
                            deletePage(delSubPage[0].detailPageId)
                        }
                    }
                }
            }
            commit(types.ELEMENT_DELETE, data)
            // 删除布局时，会先删除内部元素，activeID不清空，后续删除要用到。
            // 其余情况，删除组件后，直接置空
            if (!data.deleteLayout) {
                commit(
                    "states/changeActiveID",
                    {
                        container_id: data.container_id
                    },
                    {root: true}
                )
            }
            deleteDrawerAndPopover(rectAttr.options)

            // 同步删除抽屉和弹出框
            function deleteDrawerAndPopover(options) {
                if (
                    options.pluginName &&
                    (options.pluginName.includes("drawerPlugin") || options.pluginName.includes("popoverPlugin"))
                ) {
                    const id = options.pluginName.includes("drawerPlugin") ? data.rect_id : options.popoverPath
                    // 需要同时删除抽屉组件和抽屉内的组件
                    const pageLayout = state.page.pageLayoutList.find(item => item.options.source_id === id)
                    if (pageLayout) {
                        // 遍历通栏内的元素并删除
                        const allRects = getAllRectInNewLayout([pageLayout])
                        if (allRects && allRects.length > 0) {
                            const rectIds = allRects[0].rects
                            rectIds.forEach(rect_id => {
                                // 删除元素,调用当前action删除元素的方法
                                store.dispatch(`${window.request_prefix}/deleteElement`, {
                                    container_id: data.container_id,
                                    rect_id
                                })
                            })
                        }
                        // 过滤掉当前删除的通栏,source_id为当前rect_id的通栏，不过滤不包含source_id属性的通栏
                        let newPageLayoutList = []
                        state.page.pageLayoutList.forEach(item => {
                            if (!item.options.hasOwnProperty("source_id") || item.options.source_id !== id) {
                                newPageLayoutList.push(item)
                            }
                        })
                        commit(types.CHANGE_PAGE_LAYOUT, {pageLayoutList: newPageLayoutList})
                    }
                }
            }

            function deleteDirtyDrawer(plugin, shape) {
                if (rectAttr.options.pluginName && rectAttr.options.pluginName.includes(plugin)) {
                    // 找到当前页面的导航菜单组件
                    const rectAttr = state.page.children[0].children.find(
                        rect => rect.shape === shape
                    )
                    // 需要同时删除抽屉组件和抽屉内的组件
                    const path = findCurrentComponentPathInLayoutByRectId(state.page.pageLayoutList, rectAttr.rect_id).join("_")
                    const options = getAttrById(state,
                        {
                            pageLayoutId: path
                        },
                        "pageLayoutId")
                    const rectIds = options.rectIds
                    if (rectIds.length > 0) {
                        // 遍历通栏内的元素并删除
                        rectIds.forEach(rect_id => {
                            // 删除元素,调用当前action删除元素的方法
                            // 需要获取request_prefix
                            store.dispatch(`${window.request_prefix}/deleteElement`, {
                                container_id: data.container_id,
                                rect_id
                            })
                        })
                    }
                }
            }

            // 判断当前删除元素是否是列表页移动端列表页专用的树形菜单抽屉按钮
            deleteDirtyDrawer("listPageNavMenuDrawerPlugin", "cxNavMenuVertical")
            // 判断当前删除元素是否是列表页移动端列表页专用的多级筛选抽屉按钮
            deleteDirtyDrawer("listPageMultiFilterDrawerPlugin", "cxMultiFilter")
        },
        clearAllRect({commit, state}, data) {
            if (state.page.subPages) {
                // 清空子页面映射关系
                commit(types.CHANGE_SUB_PAGE_MAPPING, [])
            }
            commit(types.CLEAR_ALL_RECT, data)
        },
        deleteContainer({commit}, container_id) {
            commit(types.CONTAINER_DELETE, container_id)
        },
        setActive({commit, state}, {container_id, rect_id}) {
            const container = getAttrById(state, {container_id})
            for (let i = 0, l = container.children.length; i < l; i++) {
                if (container.children[i].rect_id === rect_id) {
                    commit(types.ENABLE_ACTIVE, {container_id: container_id, rect_id: container.children[i].rect_id})
                } else {
                    if (container.children[i].active) {
                        commit(types.DISABLE_ACTIVE, {
                            container_id: container_id,
                            rect_id: container.children[i].rect_id
                        })
                    }
                }
            }
        },
        unsetActive({commit}, {container_id, rect_id}) {
            commit(types.DISABLE_ACTIVE, {
                container_id: container_id,
                rect_id: rect_id
            })
        },

        setWidth({commit}, {container_id, rect_id, width}) {
            commit(types.CHANGE_WIDTH, {container_id: container_id, rect_id: rect_id, width: width})
        },
        setHeight({commit}, {container_id, rect_id, height}) {
            commit(types.CHANGE_HEIGHT, {container_id: container_id, rect_id: rect_id, height: height})
        },

        setLeft({commit}, {container_id, rect_id, left}) {
            commit(types.CHANGE_LEFT, {container_id: container_id, rect_id: rect_id, left: left})
        },
        setTop({commit}, {container_id, rect_id, top}) {
            commit(types.CHANGE_TOP, {container_id: container_id, rect_id: rect_id, top: top})
        },
        /*
        轮播组件内布局事件
        */
        changeElementInSwiperActive({commit}, data) {
            commit(types.CHANGE_ELEMENT_IN_SWIPER_ACTIVE, data)
        },
        addComponentInSwiper({commit}, data) {
            commit(types.ADD_ELEMENT_IN_SWIPER, data)
        },
        delComponentInSwiper({commit}, data) {
            commit(types.DEL_ELEMENT_IN_SWIPER, data)
        },
        changeSwiperOptions({commit}, data) {
            commit(types.CHANGE_SWIPER_OPTIONS, data)
        },
        changeSwiperContentOptions({commit}, data) {
            commit(types.CHANGE_SWIPER_CONTENT_OPTIONS, data)
        },
        /*
         自动布局组件事件
        */
        changeElementInAutoLayoutActive({commit}, data) {
            commit(types.CHANGE_ELEMENT_IN_AUTOLAYOUT_ACTIVE, data)
        },
        changeElementInAutoLayoutUnActive({commit}, data) {
            commit(types.CHANGE_ELEMENT_IN_AUTOLAYOUT_UNACTIVE, data)
        },
        addAutoLayoutElement({commit}, data) {
            commit(types.ADD_COMPONENT_IN_AUTOLAYOUT, data)
        },
        delAutoLayoutElement({commit}, data) {
            commit(types.DEL_ELEMENT_IN_AUTOLAYOUT, data)
        },
        changeAutoLayoutOptions({commit}, data) {
            commit(types.CHANGE_AUTOLAYOUT_OPTIONS, data)
        },
        /**
         * 数据列表事件
         */
        addDataGridElement({commit}, data) {
            commit(types.ADD_COMPONENT_IN_DATAGRID, data)
        },
        delDataGridElement({commit}, data) {
            commit(types.DEL_ELEMENT_IN_DATAGRID, data)
        },
        changeDataGridOptions({commit, state}, data) {
            // 当cellId==root时，修改默认单元格时，同步修改给所有单元格
            let type = ""
            if (isExist(data.elementInDataGridId)) {
                type = "elementInDataGrid"
            } else if (isExist(data.cellId) && !isExist(data.elementInDataGridId)) {
                type = "dataGridCell"
            }
            data.type = type

            let rectAttr = getAttrById(state, {...data}, "dataGrid")
            if (!rectAttr) return
            // 执行动画时，都同步
            if (data.isSync || (!data.hasOwnProperty("isSync") && data.option_name.indexOf('Animates')>-1)) {
                let cells = rectAttr.cells
                // 找到所有单元格，修改
                if (cells && cells.length > 0) {
                    const animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
                    if (animateTypes.indexOf(data.option_name) > -1) {
                        // 判断如果是外部组件控制当前列表页数据组件的动画，则将实现动画的对象存到触发动画的组件上

                        data.option_val.forEach((item, valIndex) => {
                            let isOutRectAnimate = item.ids.rect_id !== item.controlIds.rect_id ? true : false
                            if (isOutRectAnimate) {
                                let passiveDataGridRectIds = []
                                item.passiveIds.forEach(ids => {
                                    if(ids.cellId){
                                        passiveDataGridRectIds.push(ids.rect_id)
                                    }
                                })
                                cells.forEach((cell, index) => {
                                    // 对于动画，需要先处理动画的对应关系
                                    const animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
                                    if (animateTypes.indexOf(data.option_name) > -1) {
                                        // if (cell.cellId !== data.cellId) {
                                            if (item.passiveIds && item.passiveIds.length > 0) {
                                                let curCellPassiveIds = item.passiveIds.find(ids => ids.cellId === cell.cellId)
                                                if (!curCellPassiveIds) {
                                                    passiveDataGridRectIds.forEach(rectId=>{
                                                        item.passiveIds.push({
                                                            ...item.passiveIds[0],
                                                            rect_id: rectId,
                                                            cellId:cell.cellId
                                                        })
                                                    })
                                                }
                                            }
                                        // }
                                    }
                                })
                                let controlRect = getAttrById(state, {...item.controlIds})
                                controlRect = controlRect.options ? controlRect.options : controlRect
                                Vue.set(controlRect, data.option_name[valIndex], item)
                            }
                        })
                    }
                    cells.forEach((cell, index) => {
                        // 对于动画，需要先处理动画的对应关系
                        const animateTypes = ["pageloadAnimates", "hoverAnimates", "clickAnimates"]
                        let tempData = JSON.parse(JSON.stringify(data))
                        if (animateTypes.indexOf(data.option_name) > -1) {
                            tempData.option_val.forEach(item => {
                                if (item.controlIds.cellId !== cell.cellId) {
                                    if (item.passiveIds && item.passiveIds.length > 0) {
                                        item.passiveIds.forEach((passiveItem, index) => {
                                            // if (item.passiveIds[index].cellId && item.passiveIds[index].cellId !=="root" && item.controlIds.cellId === data.cellId) {
                                            if (item.passiveIds[index].cellId && item.controlIds.cellId === data.cellId) {
                                                item.passiveIds[index].cellId = cell.cellId
                                            }
                                        })
                                    }
                                    if (item.controlIds && item.controlIds.cellId) {
                                        item.controlIds.cellId = cell.cellId
                                    }
                                    if (item.ids && item.ids.cellId) {
                                        item.ids.cellId = cell.cellId
                                    }
                                }
                            })
                        }
                        tempData.cellId = cell.cellId
                        commit(types.CHANGE_DATAGRID_OPTIONS, tempData)
                    })
                }
            } else {
                commit(types.CHANGE_DATAGRID_OPTIONS, data)
            }
        },
        changeDataGridLayout({commit}, data) {
            commit(types.CHANGE_DATAGRID_LAYOUT, data)
        },
        /*
         *  页面布局事件
         */
        addElementInPageLayout({commit}, data) {
            commit(types.ADD_ELEMENT_IN_PAGE_LAYOUT, data)
        },
        delElementInPageLayout({commit}, data) {
            commit(types.DEL_ELEMENT_IN_PAGE_LAYOUT, data)
        },
        /**
         * 容器事件
         */
        setContainerActive({commit, state}, {container_id}) {
            for (let i = 0, l = state.page.children.length; i < l; i++) {
                if (state.page.children[i].container_id === container_id) {
                    commit(types.ENABLE_CONTAINER_ACTIVE, {container_id: state.page.children[i].container_id})
                    continue
                }
                commit(types.DISABLE_CONTAINER_ACTIVE, {container_id: state.page.children[i].container_id})
            }
        },
        unsetContainerActive({commit}, {container_id}) {
            commit(types.DISABLE_ACTIVE, {container_id: container_id})
        },
        changeContainerSize({commit}, data) {
            commit(types.CHANGE_CONTAINER_SIZE, data)
        },
        changeContainerData({commit}, data) {
            commit(types.CHANGE_CONTAINER_DATA, data)
        },
        countContainerHeight({commit}) {
            commit(types.COUNT_CONTAINER_HEIGHT)
        },
        insertContainer({commit}, data) {
            commit(types.INSERT_CONTAINER, data)
        },
        changeContainerPosition({commit}, data) {
            commit(types.CHANGE_CONTAINER_POSITION, data)
        },
        changeVersion({commit}) {
            commit(types.CHANGE_VERSION)
        },
        changePageType({commit}, data) {
            commit(types.CHANGE_PAGE_TYPE, data)
        },
        changeAttribute({commit}, data) {
            commit(types.CHANGE_ATTRIBUTE, data)
        },
        changeStageLayoutOption({commit}, data) {
            commit(types.CHANGE_STAGE_LAYOUT_OPTION, data)
        },
        changeContainerAttribute({commit}, data) {
            commit(types.CHANGE_CONTAINER_ATTRIBUTE, data)
        },
        changeLayoutTabsLength({commit}, data) {
            commit(types.CHANGE_LAYOUT_TABS_LENGTH, data)
        },
        initLayoutOthers({commit}, data) {
            commit(types.INIT_LAYOUT_OTHERS, data)
        },
        changeLayoutBlockSize({commit}, data) {
            commit(types.CHANGE_LAYOUT_BLOCK_SIZE, data)
        },
        changeLayoutComponentBoxOption({commit}, data) {
            commit(types.CHANGE_LAYOUT_COMPONENTBOX_OPTION, data)
        },
        changeLayoutCellBoxOptionSize({commit}, data) {
            commit(types.CHANGE_LAYOUT_CELL_BOX_OPTION_SIZE, data)
        },
        changeListPageSetting({commit}, data) {
            commit(types.CHANGE_LIST_PAGE_SETTING, data)
        },
        changeDetailPageSetting({commit}, data) {
            commit(types.CHANGE_DETAIL_PAGE_SETTING, data)
        },
        changeSubPageMapping({commit}, data) {
            commit(types.CHANGE_SUB_PAGE_MAPPING, data)
        },
        changePhoneFullScreen({commit}, data) {
            commit(types.CHANGE_PHONE_FULL_SCREEN, data)
        },
        changePageLayoutType({commit}, data) {
            commit(types.CHANGE_PAGE_LAYOUT_TYPE, data)
        },
        changeOnlyH5Template({commit}, data) {
            commit(types.CHANGE_ONLY_H5_TEMPLATE, data)
        },
        changeRowColSize({commit}, data) {
            commit(types.CHANGE_ROW_COL_SIZE, data)
        },
        changeRowColUid({commit}, data) {
            commit(types.CHANGE_ROW_COL_UID, data)
        },
        changePageLayout({commit}, data) {
            commit(types.CHANGE_PAGE_LAYOUT, data)
        },
        insertPageLayout({commit}, data) {
            commit(types.INSERT_PAGE_LAYOUT, data)
        },
        changePageLayoutRow({commit}, data) {
            commit(types.CHANGE_PAGE_LAYOUT_ROW, data)
        },
        changePageLayoutTabslength({commit}, data) {
            commit(types.CHANGE_PAGE_LAYOUT_TABS_LENGTH, data)
        },
        changeBayWindowStatus({commit}) {
            commit(types.CHANGE_BAYWINDOW_STATUS)
        },
        changeLayoutBlockByTabs({commit}, data) {
            commit(types.CHANGE_LAYOUT_BLOCK_BY_TABS, data)
        },
    }
}
